<template>
  <div
    class="card modal"
    :style="{ maxWidth: modal.maxWidth }"
    ref="panel"
    role="dialog"
    aria-modal="true"
    @click.stop
  >
    <header class="card-header">
      <h2>{{ modal.title }}</h2>
      <button
        v-if="modal.dismissible"
        class="card-close"
        @click="$emit('close')"
        ref="closeBtn"
      >
        ✕
      </button>
    </header>

    <section class="card-content">
      <p v-if="modal.kind === 'alert' || modal.kind === 'confirm'" style="white-space: pre-line;">
        {{ modal.message }}
      </p>
      <component
        v-else-if="modal.component"
        :is="modal.component"
        v-bind="modal.props"
        ref="componentRef"
        @submit="handleSubmit"
        @cancel="$emit('cancel')"
      />
    </section>

    <footer class="card-footer" v-if="modal.kind !== 'custom'">
      <button
        v-if="modal.showCancel"
        class="btn btn-secondary"
        @click="$emit('cancel')"
      >
        {{ modal.cancelText }}
      </button>
      <button
        v-if="modal.showConfirm"
        class="btn btn-primary"
        @click="handleConfirm"
        @keydown.enter.prevent="handleConfirm"
        :disabled="modal.loading"
      >
        {{ modal.loading ? 'Chargement...' : modal.confirmText }}
      </button>
    </footer>
  </div>
</template>


<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'

const props = defineProps({ modal: Object })
const emit = defineEmits(['close', 'confirm', 'cancel', 'submit'])

const panel = ref(null)
const closeBtn = ref(null)
const previousFocus = ref(null)
const componentRef = ref(null)

const handleSubmit = (data) => {
  console.log('📨 BaseModal reçoit:', data)
  emit('submit', data)
}

const handleConfirm = () => {
  console.log('🔘 Bouton Confirmer cliqué')
  console.log('📦 componentRef.value:', componentRef.value)

  if (componentRef.value && typeof componentRef.value.handleSubmit === 'function') {
    console.log('✅ Appel de handleSubmit du composant')
    componentRef.value.handleSubmit()
  } else {
    console.log('⚠️ Pas de handleSubmit, emit confirm')
    emit('confirm')
  }
}

onMounted(async () => {
  previousFocus.value = document.activeElement
  await nextTick()
  closeBtn.value?.focus()
  document.addEventListener('keydown', trapFocus)
  document.addEventListener('keydown', handleEscape)
})

onUnmounted(() => {
  document.removeEventListener('keydown', trapFocus)
  document.removeEventListener('keydown', handleEscape)
  previousFocus.value?.focus()
})

function trapFocus(e) {
  if (e.key !== 'Tab' || !panel.value) return

  const focusable = panel.value.querySelectorAll(
    'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )

  if (focusable.length === 0) return

  const first = focusable[0]
  const last = focusable[focusable.length - 1]

  if (e.shiftKey && document.activeElement === first) {
    last.focus()
    e.preventDefault()
  } else if (!e.shiftKey && document.activeElement === last) {
    first.focus()
    e.preventDefault()
  }
}

function handleEscape(e) {
  if (e.key === 'Escape' && props.modal.closeOnEsc && props.modal.dismissible) {
    emit('close')
  }
}
</script>

<style scoped>
.card,.modal {
  padding: 0;
  width: min(75vw, 700px);
  border: none;
  box-shadow: var(--shadow-lg);
  overflow: auto;
  max-height: 90vh;
  border-radius: 8px;
}
.card-content,.modal-content {
  padding: 0.5rem 1.5rem;
}
.card-close,.modal-close {
  background: none; border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #999; transition: color 0.3s;
  width: 30px; height: 30px;
  display: flex; align-items: center; justify-content: center;
}
.card-close:hover { color: var(--color-jungle); }
.btn-secondary {
  padding: 0.5rem 1.5rem !important;
}
/* :deep(.card-content > .form-group > .group-rows:last-child > .group-columns:last-child) { */
/*   flex: 2; */
/* } */
@media (max-width: 768px) {
  /* .card-header, */
  /* .card-footer, */
  /* .card-content { */
  /*   padding: 0.5rem 1rem !important; */
  /* } */
  /* button { */
  /*   font-size: 0.8rem !important; */
  /* } */
  .card-footer {
    gap: 0.5rem;
    /* flex-direction: row; */
    /* align-items: stretch; */
    /* justify-content: center; */
  }
  /* .card-footer .btn { */
  /*   width: 100%; */
  /* } */
}
</style>
